import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import ReactSlick from 'react-slick';
import loadTranslations from 'js/localeSetup';
import ArrowSvg from './ArrowSvg';

import './superstarSlider.less';

function PrevArrow({ className, onClick }) {
  return (
    <div
      className={`${className} arrowLeft video-slider-prev`}
      onClick={onClick}
      role="button"
      tabIndex="0"
      style={{ outline: 'none' }}
    >
      <ArrowSvg direction="prev" />
    </div>
  );
}

function NextArrow({ className, onClick }) {
  return (
    <div
      className={`${className} arrowRight video-slider-next`}
      onClick={onClick}
      role="button"
      tabIndex="0"
      style={{ outline: 'none' }}
    >
      <ArrowSvg direction="next" />
    </div>
  );
}

class SuperstarSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: window.config.language_code,
      superStars: [],
      videoText: '',
      videoShopnowUrl: '',
      videoShopnowText: '',
      video: '',
      videoOpen: false,
      pictureStyle: {
        width: '100%',
        display: 'block'
      },
      dragging: false
    };
  }

  componentDidMount() {
    this.setState({
      superStars: this.handleShuffle(this.props.stars)
    });
  }

  handleShuffle = array => {
    const stars = [...array];
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = stars[currentIndex];
      stars[currentIndex] = stars[randomIndex];
      stars[randomIndex] = temporaryValue;
    }
    return stars;
  };

  handleOpenVideo = (videoText, videoShopnowUrl, videoShopnowText, video) => {
    window.ua('trackStructEvent', 'clicked superstar');
    this.setState({
      videoText,
      videoShopnowUrl,
      videoShopnowText,
      video,
      videoOpen: true
    });
  };

  handleCloseVideo = () => {
    this.setState({
      videoText: '',
      videoShopnowUrl: '',
      videoShopnowText: '',
      video: '',
      videoOpen: false
    });
  };

  render() {
    const params = {
      customPaging: i => (
        <span
          className="swiper-pagination-bullet"
          tabIndex="0"
          role="button"
          aria-label={`Go to slide ${i + 1}`}
        />
      ),
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      dotsClass: 'video-slider-pagination',
      arrows: true,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      infinite: false,
      lazyLoad: true,
      touchThreshold: 15,
      speed: 300,
      beforeChange: () => this.setState({ dragging: true }),
      afterChange: () => this.setState({ dragging: false })
    };
    return (
      <div className="video-slider">
        {this.state.videoOpen && (
          <div
            className="video-slider-video-background"
            onClick={this.handleCloseVideo}
            role="button"
            tabIndex="0"
            style={{ outline: 'none' }}
          >
            <div className="close" />
            <div className="video-slider-video-container">
              <div className="video-slider-video-holder">
                <iframe
                  src={this.state.video}
                  className="video-slider-video"
                  title="video-slider-video"
                  width={640}
                  height={360}
                  frameBorder={0}
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    left: 0
                  }}
                  allowFullScreen
                />
              </div>
              <div className="video-slider-video-text">
                <p>
                  {this.state.videoText}
                  <a href={this.state.videoShopnowUrl}>
                    {this.state.videoShopnowText}
                  </a>
                </p>
              </div>
            </div>
          </div>
        )}
        {this.state.superStars.length > 0 ? (
          <ReactSlick {...params}>
            {this.state.superStars.map(slide => {
              if (!slide.videos[this.state.lang]) {
                return false;
              }
              return (
                <div
                  className="swiper-slide"
                  key={slide.videos[this.state.lang]}
                >
                  <div
                    className="video-slider-container"
                    onClick={() =>
                      !this.state.dragging &&
                      this.handleOpenVideo(
                        slide.videoText,
                        slide.urls[this.state.lang],
                        slide.videoShopnowText,
                        slide.videos[this.state.lang]
                      )
                    }
                    role="button"
                    tabIndex="0"
                    style={{ outline: 'none' }}
                  >
                    <picture>
                      <source
                        srcSet={slide.image[0]}
                        media="(min-width: 1680px)"
                        alt="football superstar"
                      />
                      <source
                        srcSet={slide.image[1]}
                        media="(min-width: 600px)"
                        alt="football superstar"
                      />
                      <img
                        src={slide.image[2]}
                        alt="football superstar"
                        style={this.state.pictureStyle}
                      />
                    </picture>
                    <div className="video-slider-textholder">
                      <h3 className="video-slider-title">{slide.title}</h3>
                      {/* <p className="video-slider-text">{slide.text}</p> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </ReactSlick>
        ) : null}
      </div>
    );
  }
}
(async () => {
  const rootElement = document.getElementById('superstarSlider');
  const { default: data } = await import('./superStarData');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<SuperstarSlider stars={data} />, rootElement);
  }
})();
